import {Endpoints} from "../Endpoints";
import Backend from "../../Backend";
export default class FileUpload
{
  constructor(token)
	{
		this.backend = new Backend(token);
	}

  add(file, callback)
  {
    this.backend.callBackend(`${Endpoints.file.private}/upload`, callback, "POST", file);
  }

  downloadPDFDocument(file, callback) {
    this.backend.callBackend(`${Endpoints.file.private}/upload/document?documentType=${file}`,callback,"GET");
}

  deletePDFDocument(file, uuid,callback)
  {
    this.backend.callBackend(`${Endpoints.file.private}/upload/document?documentType=${file}&name=${uuid}`, callback, "DELETE");
  }
  getPDFDocument(callback){
    this.backend.callBackend(`${Endpoints.file.private}/upload/document/all`,callback,"GET")
  }
 
  uploadPDFDocument(fileType,file,callback){
    const formData = new FormData();
    formData.append("file", file);
    this.backend.callBackend(`${Endpoints.file.private}/upload/document?documentType=${fileType}`,callback,"POST",formData,false)
  }
  getPogress(purchasername,callback){
    this.backend.callBackend(`${Endpoints.pogress.private}/${purchasername}/progress`,callback,"GET")

  }
}